import useUser from 'utils/useUser';
import { BroadcastTopics } from 'services/wsService';

import { useWebsocketRoom } from '../websockets/use-room';
import { useSocketOn } from '../websockets/use-socket-on';

import type { IPatientAssignStateChange } from 'infrastructure/interfaces';

export const useAssignRoom = (
  callBack: (data: IPatientAssignStateChange) => void,
) => {
  const { isAgencyDoctor } = useUser();

  useWebsocketRoom('interactiveTimeAssign', { enabled: isAgencyDoctor });

  useSocketOn<IPatientAssignStateChange>(
    BroadcastTopics.PatientAssignStateChange,
    callBack,
  );
};
